import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
	MatterAdjustmentSalePrice,
	MatterAdjustmentSalePriceCalculated,
	MatterAdjustmentSalePriceRebatesCalculated,
} from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { Observable } from 'rxjs';

@UntilDestroy()
@Component({
	selector: 'app-hst-rebate-dialog',
	templateUrl: './hst-rebate-dialog.component.html',
	standalone: false,
})
export class HstRebateDialogComponent implements OnInit {
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceRebateCalculated)
	salePriceRebateCalculated: MatterAdjustmentSalePriceRebatesCalculated;
	@ViewSelectSnapshot(AdjustmentsSelector.salePriceAdjustmentCalculated)
	salePriceAdjustmentCalculated: MatterAdjustmentSalePriceCalculated;
	@Select(AdjustmentsSelector.salePriceAdjustment)
	salePriceAdjustment$: Observable<MatterAdjustmentSalePrice>;

	public salePriceAdjustment: MatterAdjustmentSalePrice;

	constructor(
		private dialogRef: MatDialogRef<HstRebateDialogComponent>,
		private adjustmentDispatch: AdjustmentsDispatch,
	) {}

	ngOnInit() {
		this.salePriceAdjustment$
			.pipe(untilDestroyed(this))
			.subscribe((adjustment) => {
				this.salePriceAdjustment = adjustment;
			});
	}

	toggleDetails(state: boolean) {
		if (this.salePriceAdjustment?.hstRebate) {
			this.salePriceAdjustment.hstRebate.details = state;
		} else {
			this.salePriceAdjustment.hstRebate = {
				details: state,
			};
		}
	}

	toggleSingleAdjustments(state: boolean) {
		if (this.salePriceAdjustment?.hstRebate) {
			this.salePriceAdjustment.hstRebate.fedAndProvAsSingleAdjustments = state;
		} else {
			this.salePriceAdjustment.hstRebate = {
				fedAndProvAsSingleAdjustments: state,
			};
		}
	}

	save() {
		this.adjustmentDispatch.Set(this.salePriceAdjustment);
		this.dialogRef.close();
	}
}
